export enum LoadPlanViewTabs {
  CollectContainer = 'CONTAINER DETAILS',
  Receive = 'RECEIVE LOAD PLAN',
}
